export enum SubUserPermissionE {
  OWNER = "Owner",
  ADMIN = "Admin",
  USER = "User",
  SUPERVISOR = "Supervisor",
}

export enum SubUserStatusE {
  ACTIVE = "Active",
  SUSPENDED = "Suspended",
  PENDING = "Pending",
  EXPIRED = "Expired",
}

export enum UserOccupationE {
  PHOTOGRAPHER = "oc021",
}

export enum CustomDomainPagesE {
  GALLERY = "gallery", // from mailId
  COLLECTION = "collection", // from mailId
  LOGIN = "login",
  PASSWORD_RECOVER = "password-recover",
  UPLOAD = "upload",
  CREATE_FORM = "create-form",
  FORM = "form",
  ORDER_TRACKER = "order-tracker",
  USER = "user",
  PROFILE = "profile",
  PAGE_EDIT = "page-edit",
  PAGE = "page", // GetUploadEndpointApiRequest(pageOwnerUserId)
  INBOX = "inbox",
  PICKER_SUCCESS = "picker-success",
  HOME = "home",
  SUB_USER_COMPLETE = "sub-user-complete",
  INVITE = "invite",
  REGISTRATION_COMPLETE = "registration-complete",
  USER_CONFIRMATION = "user-confirmation",
  J = "j",
  EMBED_DYNAMICS = "EmbedDynamics",
}

export enum MainDomainPagesE {
  ERROR = "error",
  SUBSCRIBERS = "subscribers",
  J = "j",
  PLANS = "plans",
  JUMBO_FORMS = "jumbo-forms",
  REGISTRATION = "registration",
  FOR_BUSINESSES = "for-businesses",
  JUMBO_PICKER = "jumbo-picker",
  ABOUT = "about",
  UPLOAD_SPEED_TEST = "upload-speed-test",
  RESET_PASSWORD = "reset-password",
  CODES = "codes",
  EMAIL_PREFERENCES = "email-preferences",
  JUMBO_PAY = "jumbo-pay",
  CONTACT_US = "contact-us",
  SUPPORT = "support",
  FEATURES = "features",
  BLOG = "blog",
  BLOG_ARTICLE = "blog",
  NEWS = "news",
  STAGE = "stage",
  STAGE_CREATOR = "stage",
  PURCHASE = "purchase",
  TERNS = "terms",
  ACCOUNT_DELETED = "account-deleted",
  PURCHASE_ERROR_RETRY = "purchase-error-retry",
  AUTHENTICATE_LOGIN = "authenticate-login",
  AUTHENTICATE_USER = "authenticate-user",
  USER_CONFIRMATION = "user-confirmation",
}
